export const enumToValues = <T extends object>(enumObject: T) => {
	return Object.values(enumObject).filter(
		(v) => typeof v === 'number',
	) as T[keyof T][];
};

export default enumToValues;
